import { CapoPlugin } from "/var/www_vsf/releases/70dbdf7b-aa7d-4805-b46a-8faef61a0aff/node_modules/@unhead/vue/dist/index.mjs";
export default import.meta.server ? [CapoPlugin({ track: true })] : [];